<div class="container">
    <div class="header">
        <span class="description" data-cy="ops-settings-accounts-total-count">
            {{
                (userList?.length >= 10 ? 'account-settings.description.limit-reached' : 'account-settings.description')
                    | translate: { userNum: userList?.length || 0 }
            }}
        </span>
        <div class="button-group">
            <app-button
                class="new-button"
                text="account-setting.session.timeout.title"
                variant="edit"
                [iconButton]="true"
                iconSize="20px"
                icon="avg-pace"
                [disable]="userList?.length <= 0 || !userCanEdit"
                (onClick)="editSessionTimeout()"></app-button>
            <app-button
                class="edit-button"
                text="account-setting.edit.permissions.dialog.title"
                variant="edit"
                [iconButton]="true"
                iconSize="20px"
                icon="edit-pen"
                [disable]="!userCanEdit"
                (onClick)="editPermissions()"></app-button>
            <app-button
                class="new-button"
                text="account-setting.create.dialog.title"
                [iconButton]="true"
                [noneMarginIcon]="true"
                iconSize="20px"
                icon="plus"
                [disable]="userList?.length >= 10 || !userCanEdit"
                (onClick)="createAccount()"></app-button>
        </div>
    </div>
    <div class="content" data-cy="ops-settings-accounts-account-list">
        <div class="content-header">
            <div class="cell content-header-cell" data-cy="ops-settings-accounts-table-account-col-header">
                {{ 'account-settings.header.account' | translate }}
            </div>
            <div class="cell content-header-cell" data-cy="ops-settings-accounts-table-password-col-header">
                {{ 'account-settings.header.password' | translate }}
            </div>
            <div class="options content-header-cell"></div>
        </div>
        <div
            *ngFor="let user of userList; let i = index"
            class="content-rows"
            data-cy="ops-settings-accounts-account-list-item">
            <div class="cell name content-cell" data-cy="ops-settings-accounts-account-name">
                {{ user.name }}
            </div>
            <div class="cell password content-cell" data-cy="ops-settings-accounts-account-password">
                {{ user.passwordVisible ? user.password : '*'.repeat(user.password?.length) }}
                <mat-icon
                    class="visible-icon"
                    data-cy="ops-settings-accounts-show-hide-password-icon"
                    [svgIcon]="user.passwordVisible ? 'visible' : 'invisible'"
                    (click)="passwordModeChange(user, i)">
                </mat-icon>
            </div>

            <div class="options content-cell">
                <mat-icon
                    svgIcon="more-options"
                    class="more-options-icon"
                    data-cy="ops-settings-accounts-account-list-kebab-icon"
                    (click)="optionsIconClick(user); $event.stopPropagation()"
                    [class.disabled]="!userCanEdit"></mat-icon>
                <div class="options-dialog" [class.show]="user.showOptionsDialog">
                    <div
                        class="options-item"
                        data-cy="ops-settings-accounts-kebab-menu-edit"
                        (click)="editAccount(user)">
                        {{ 'dlg.edit' | translate }}
                    </div>
                    <div
                        class="options-item"
                        data-cy="ops-settings-accounts-kebab-menu-delete"
                        (click)="deleteAccount(user)"
                        [ngClass]="{ disable: user.isAdmin }">
                        {{ 'channel.more-option.delete' | translate }}
                    </div>
                    <div
                        class="options-item"
                        data-cy="ops-settings-accounts-kebab-menu-duplicate"
                        (click)="duplicateAccount(user)"
                        [ngClass]="{ disable: user.isAdmin }">
                        {{ 'channel.more-option.duplicate' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #deleteDialog
    [subLabel]="'account-settings.delete.sub.message'"
    [mainLabel]="deleteDialogMainLabel"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"></app-confirmation-window>

<app-confirmation-window
    #errorDialog
    [subLabel]="dialogErrorMessage"
    [saveLabel]="'dlg.notification.close-button'"></app-confirmation-window>
